import { useState } from "react";
import { IAirdropTaskRender } from "./task-renderer.types";
import { QuestTaskButton } from "../quest-task-button";

export const SecretCodeRenderer = ({
  task,
  campaign,
  completeTaskMutation,
}: IAirdropTaskRender) => {
  const [secretCode, setSecretCode] = useState("");

  return (
    <div className="flex flex-col gap-4">
      <div className="relative bg-yiedl-gray-200 border-2 border-neutral-800 rounded-xl p-4">
        <input
          type="text"
          value={secretCode}
          onChange={(e) => setSecretCode(e.target.value)}
          placeholder="Enter secret code"
          className="w-full bg-transparent border-none outline-none text-white placeholder:text-gray-500 text-sm text-center font-mono"
        />
      </div>

      <QuestTaskButton
        buttonText="Submit Code"
        taskMutation={completeTaskMutation}
        task={task}
        onClick={() => {
          completeTaskMutation.mutateAsync({
            taskGuid: task.taskGuid,
            taskName: task.taskName,
            campaignId: campaign.id,
            extraArguments: [secretCode.trim()],
            groupId: campaign.campaignGroup,
          });
        }}
      />
    </div>
  );
};
